<div class="flex flex-col pt-6 h-svh">
  <div class="self-end">
    <img
      (click)="closeTab()"
      class="mr-2 cursor-pointer"
      src="../../../../../assets/images/svg/cross-close.svg"
    />
  </div>
  <div class="flex-1 text-center content-center">
    <img src="../../../../../assets/images/svg/cross-error.svg" class="m-auto" />
    <p class="font-bold text-lg mt-6">{{ 'connection_attempt_has_failed' | translate }}</p>
    <p class="mt-4 text-sm">{{ 'you_can_close_this_tab' | translate }}</p>
  </div>
  <div>
    <button
      class="bg-primary font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full"
      (click)="closeTab()"
    >
      {{ 'close_tab' | translate }}
    </button>
  </div>
</div>
